// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3DnRp","footer":"ModalFilter_footer__2UIfg"};